import BetModel from '../../vendor_core/core/src/model/BetModel';
import AbstractVendorBetConfig from '../../vendor_core/src/vendorConfigs/AbstractVendorBetConfig';

class BetConfig extends AbstractVendorBetConfig {
    public betOptions = [];
    public getBetOptions(): number[] {
        const betOptions = super.getBetOptions();
        const reducedBetOption = betOptions.reduce((acc, value) => {
            if (value <= BetModel.balance) {
                acc.push(value)
            }

            return acc
        }, [])

        return reducedBetOption
    }

}

export default new BetConfig()
